export interface ApiResponse<T> {
  model: T;
  code: number;
  success: boolean;
}
